import { render, staticRenderFns } from "./ZhanhuiRankedByDw.vue?vue&type=template&id=5f042c66&scoped=true"
import script from "./ZhanhuiRankedByDw.vue?vue&type=script&lang=js"
export * from "./ZhanhuiRankedByDw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f042c66",
  null
  
)

export default component.exports